/**
 * The entries of a multiple-choice field, whatever shape its value arrived in.
 *
 * The server stores a list of the options' spellings as JSON
 * (`["Impôt","Tenue de livres"]`) in the same text column as every other
 * custom value, a form binds an array, and a value typed by hand is a
 * comma-separated string. All three read as the same list here.
 *
 * Mirrors `App\Fields\FieldChoices::entries()`.
 */
export function choiceEntries(value) {
    if (value === null || value === undefined || value === '') return [];

    if (Array.isArray(value)) return value.map(entry => String(entry).trim()).filter(Boolean);

    const text = String(value).trim();

    if (text.startsWith('[')) {
        try {
            const decoded = JSON.parse(text);

            if (Array.isArray(decoded)) return choiceEntries(decoded);
        } catch {
            // Not a stored list after all: read it as typed text below.
        }
    }

    return text
        .split(/\s*[,;]\s*/)
        .map(entry => entry.trim())
        .filter(Boolean);
}

/** A field's options as the strings stored for them — a custom field declares plain strings. */
export function choiceOptions(options) {
    return (options || [])
        .map(option => (option && typeof option === 'object' ? (option.value ?? option.label) : option))
        .filter(option => option !== null && option !== undefined && option !== '')
        .map(String);
}
